"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirdropDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("../Dataset");
/**
 * Airdrop dataset.
 */
class AirdropDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Airdrop tokens.
         *
         * @param req Use {@link Build5Request} with data based on {@link CreateAirdropsRequest}
         * @returns
         */
        this.airdropToken = (req) => this.sendRequest(interfaces_1.WEN_FUNC.airdropToken)(req);
        /**
         * Airdrop minted tokens.
         *
         * @param req Use {@link Build5Request} with data based on {@link CreateAirdropsRequest}
         * @returns
         */
        this.airdropMintedToken = (req) => this.sendRequest(interfaces_1.WEN_FUNC.airdropMintedToken)(req);
        /**
         * Claimed minted token airdrop.
         *
         * @param req Use {@link Build5Request} with data based on {@link ClaimAirdroppedTokensRequest}
         * @returns
         */
        this.claimMintedAirdrop = (req) => this.sendRequest(interfaces_1.WEN_FUNC.claimMintedTokenOrder)(req);
        /**
         * Claim token airdrop.
         *
         * @param req Use {@link Build5Request} with data based on {@link ClaimPreMintedAirdroppedTokensRequest}
         * @returns
         */
        this.claimAirdropped = (req) => this.sendRequest(interfaces_1.WEN_FUNC.claimAirdroppedToken)(req);
    }
}
exports.AirdropDataset = AirdropDataset;
